import { jwtDecode } from "jwt-decode";

/**
 * Verifies if user is authenticated
 * @returns {boolean} Returns true if JWT is valid, false otherwise.
 */
export const isAuthenticated = () => {
  const token = localStorage.getItem("authToken");
  if (!token) return false;
  try {
    // Decode token and verify expiration date
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000; // Convert milliseconds to seconds
    return decoded.exp > currentTime; // Return true if token hasn't expired
  } catch (error) {
    console.error("Error al validar el token:", error);
    return false;
  }
};

/**
 * Gets the user's level from the JWT
 * @returns {number} The user's level, or 0 if not found
 */
export const getUserLevel = () => {
  const token = localStorage.getItem("authToken");
  if (!token) return 0; // Si no hay token, retorna nivel 0 (sin permisos)

  try {
    const decoded = jwtDecode(token);
    return decoded.user_type_id || 0; // Si el nivel no existe, retorna 0
  } catch (error) {
    console.error("Error al obtener el nivel del usuario:", error);
    return 0;
  }
};

/**
 * Verifies if user is a project manager
 * @returns {boolean} Returns true if the user is a project manager, false otherwise.
 */
export const isProjectManager = () => {
  const token = localStorage.getItem("authToken");
  if (!token) return false;
  try {
    // Decode token and verify expiration date
    const decoded = jwtDecode(token);
    if(decoded && decoded.is_pm === true){
      return true;
    }
  } catch (error) {
    console.error("Error al validar el token:", error);
    return false;
  }
};
